import { getLowCodeConfig } from '@/service/lowcode';

const localGlobalConfig = require('@/static/global.config.json');

const state = {
  globalConfig: localGlobalConfig || {},
};

const getters = {};

const mutations = {
  SET_GLOBAL_CONFIG(state, data) {
    state.globalConfig = data;
  },
};

const actions = {
  async getLowCodeConfig({ commit }, data) {
    try {
      let res = await getLowCodeConfig(data);
      if (res.suc) {
        let pageInfo = res.pageInfo;
        if (pageInfo && pageInfo.schema) {
          let data = JSON.parse(pageInfo.schema);
          commit('SET_GLOBAL_CONFIG', data);
        }
      }
    } catch (e) {}
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
